import { ItinResourceProps } from "../types";

export const LegResource: ItinResourceProps = {
  name: "legs",
  // edit: LegEdit,
  // create: LegCreate,
  recordRepresentation: (r) => r.title,
};
export * from "./LegList";
